// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__T5r2p","title":"Modal_title__50ln3","text":"Modal_text__I5GVu","button":"Modal_button__iWV3F"};